import { render } from "./index.vue?vue&type=template&id=b795e132&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=b795e132&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=b795e132&lang=scss"
script.render = render
script.__scopeId = "data-v-b795e132"

export default script